import styled from "styled-components";

import { CountryDropdown } from "../../../../../../components/Form/PhoneNumberInput/styles";
import { SAVE_BAR_Z_INDEX } from "../../../../../../components/SaveBar/styles";
import { fieldLabel } from "../../styles";

/** A picker: its role, and the font it has written in itself, the list opening under it. */
export const Field = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0.375rem;
  font-family: Inter, sans-serif;

  /* as the other labels of the screen (Alinhamento's) */
  .role {
    ${fieldLabel}
  }

  .value {
    display: flex;
    gap: 0.75rem;
    align-items: center;
    width: 100%;
    height: 52px;
    padding: 0 1rem;
    color: var(--color-neutral-white);
    font-size: 1rem;
    text-align: left;
    cursor: pointer;
    /* lighter than the card it sits on */
    background: var(--color-neutral-base);
    border: 2px solid transparent;
    border-radius: 12px;
    transition: border-color 0.15s;

    &:hover {
      border-color: rgba(255, 255, 255, 0.2);
    }

    &[aria-expanded="true"] {
      border-color: var(--color-brand-blue);
    }

    /* the arrow of a list */
    &::after {
      flex-shrink: 0;
      width: 8px;
      height: 8px;
      margin-left: auto;
      content: "";
      border-right: 2px solid currentColor;
      border-bottom: 2px solid currentColor;
      transform: translateY(-2px) rotate(45deg);
    }
  }

  .name {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
`;

export const Dropdown = styled(CountryDropdown)`
  /* over the fixed Salvar bar, which would cut the list near the end of the screen */
  z-index: ${SAVE_BAR_Z_INDEX + 1};
  top: calc(100% + 0.25rem);
  left: 0;
  width: 100%;
  max-height: min(22rem, 55vh);
  overflow: auto;

  &:focus {
    outline: none;
  }

  /* each category apart: room around its title, a line between them */
  [role="group"] {
    padding: 0.25rem 0 0.5rem;
  }

  [role="group"] + [role="group"] {
    margin-top: 0.25rem;
    border-top: 1px solid rgba(255, 255, 255, 0.12);
  }

  .category {
    display: block;
    padding: 0.75rem 1rem 0.5rem;
    color: var(--color-neutral-150);
    font-family: Inter, sans-serif;
    font-size: 0.6875rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }

  ul {
    padding: 0;
    margin: 0;
    list-style: none;
  }
`;

/** A font of the list, written in itself; a PLUS one, without PLUS, a bit faded. */
export const Option = styled.li<{ $active: boolean; $locked: boolean }>`
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: space-between;
  padding: 0.625rem 1rem;
  color: var(--color-neutral-white);
  font-size: 1rem;
  cursor: pointer;
  background: ${({ $active }) => ($active ? "var(--color-neutral-base)" : "transparent")};
  opacity: ${({ $locked }) => ($locked ? 0.55 : 1)};

  &[aria-selected="true"]::after {
    flex-shrink: 0;
    width: 6px;
    height: 11px;
    content: "";
    border-right: 2px solid var(--color-brand-plus);
    border-bottom: 2px solid var(--color-brand-plus);
    transform: rotate(45deg) translateY(-2px);
  }
`;
